
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events/page/[id]",
      function () {
        return require("private-next-pages/events/page/[id].tsx");
      }
    ]);
  